








import {Component, Vue} from 'vue-property-decorator';
import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from './pbi-dict-workspace-id';

@Component({
  name: 'PbiMarketDiagnosisFiatDealerGroupPage',
  components: { ReportPowerBiContainer }
})
export default class PbiMarketDiagnosisFiatDealerGroupPage extends Vue {
  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public crrReport = {
    reportId: '3506d84f-dbab-4ada-81b6-a9a2a5f80150',
    workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash]
  }
}
